import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API from '../api';

export default function BulkUpload() {
  const [file, setFile] = useState(null);
  const navigate = useNavigate();

  const handleDownloadTemplate = async () => {
    try {
      const response = await API.get('/customers/template', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'customers_template.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('Template downloaded successfully');
    } catch (err) {
      toast.error('Failed to download template');
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === 'text/csv') {
      setFile(selectedFile);
    } else {
      toast.error('Please select a valid CSV file');
      setFile(null);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error('No file selected');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await API.post('/customers/bulk', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success(response.data.message);
      setTimeout(() => navigate('/dashboard'), 2000); // Redirect to dashboard
    } catch (err) {
      const message = err.response?.data?.message || 'Failed to upload CSV';
      const errors = err.response?.data?.errors;
      if (errors) {
        toast.error(
          <div>
            <p>{message}</p>
            <ul className="list-disc pl-5">
              {errors.map((error, idx) => (
                <li key={idx}>
                  Row {error.row}: {error.errors.join(', ')}
                </li>
              ))}
            </ul>
          </div>,
          { autoClose: 10000 }
        );
      } else {
        toast.error(message);
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 to-blue-300">
      <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-xl">
        <h2 className="text-3xl font-bold text-center text-blue-700 mb-8">
          Bulk Customer Upload
        </h2>
        <div className="mb-6">
          <button
            onClick={handleDownloadTemplate}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 rounded-lg transition duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 mb-4"
          >
            Download CSV Template
          </button>
          <form onSubmit={handleUpload}>
            <div className="mb-4">
              <label htmlFor="file" className="block text-sm font-medium text-gray-700 mb-1">
                Upload CSV File
              </label>
              <input
                id="file"
                type="file"
                accept=".csv"
                onChange={handleFileChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-lg transition duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              
              Upload and Create Customers
            </button>
          </form>
        </div>
        <p className="mt-6 text-center text-sm text-gray-600">
          Back to <Link to="/dashboard" className="text-blue-600 hover:underline">Dashboard</Link>
        </p>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </div>
  );
}